"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const address_1 = __importDefault(require("../address"));
const contact_1 = __importDefault(require("../contact"));
class Partner {
    constructor(id, name, address, partnerType, parentId, payByInvoice, masterPolicyId, currency, duplicateChecking, primaryContact, brokerContact, underwriterContact, zone, isEnabled, lastModifiedPartnerConfigDate, dunsId, eLeadSource) {
        this.id = id;
        this.name = name;
        this.address = address;
        this.partnerType = partnerType;
        this.parentId = parentId;
        this.payByInvoice = payByInvoice;
        this.masterPolicyId = masterPolicyId;
        this.currency = currency;
        this.duplicateChecking = duplicateChecking;
        this.primaryContact = primaryContact;
        this.brokerContact = brokerContact;
        this.underwriterContact = underwriterContact;
        this.zone = zone;
        this.isEnabled = isEnabled;
        this.lastModifiedPartnerConfigDate = lastModifiedPartnerConfigDate;
        this.dunsId = dunsId;
        this.eLeadSource = eLeadSource;
    }
    static fromObj(data) {
        var _a, _b, _c;
        const address = address_1.default.fromObj((_a = data.address) !== null && _a !== void 0 ? _a : address_1.default.empty());
        return new Partner(data.id, data.name, address, data.partnerType, data.parentId, !!data.payByInvoice, data.masterPolicyId, data.currency, data.duplicateChecking, data.primaryContact ? contact_1.default.fromObj(data.primaryContact) : undefined, data.brokerContact ? contact_1.default.fromObj(data.brokerContact) : undefined, data.underwriterContact
            ? contact_1.default.fromObj(data.underwriterContact)
            : undefined, data.zone, data.isEnabled !== false, (_b = data.lastModifiedPartnerConfigDate) !== null && _b !== void 0 ? _b : data.createdDate, data.dunsId, (_c = data.eLeadSource) !== null && _c !== void 0 ? _c : _1.eLeadSourceType.MANUAL_PORTAL);
    }
}
exports.default = Partner;
//# sourceMappingURL=partner.class.js.map